import React, { useRef, useEffect, useState } from 'react'
import IdleTimer from 'react-idle-timer'
import { Alert, Modal, Button } from 'rsuite'
import { clearSession, logout } from './redux/actions/auth'
import CancelButton from './components/buttons/cancelButton/CancelButton'
import SaveButton from './components/buttons/saveButton/SaveButton'

const SESSION_TIMEOUT = 1000 * 60 * 30 // 30 นาที
const WARNING_TIME = 1000 * 60 * 1 // เตือนก่อน 1 นาที

export default function SessionTimeoutProvider({ children }) {
  const idleTimer = useRef(null)
  const warningTimer = useRef(null)
  const [showWarning, setShowWarning] = useState(false)
  const [countdown, setCountdown] = useState(60)

  // logout
  const handleLogout = async () => {
    setShowWarning(false)

    try {
      const result = await logout()
      clearSession(result)
    } catch (e) {
      clearSession()
    }
  }

  // reset timer ทุก activity
  const resetWarningTimer = () => {
    clearTimeout(warningTimer.current)

    warningTimer.current = setTimeout(() => {
      setShowWarning(true)
    }, SESSION_TIMEOUT - WARNING_TIME)
  }

  // user active
  const onAction = () => {
    // sync หลาย tab
    localStorage.setItem('LAST_ACTIVITY', Date.now().toString())

    // ปิด warning ถ้ามี activity
    if (showWarning) {
      setShowWarning(false)
      setCountdown(60)
    }

    resetWarningTimer()
  }

  // idle ครบ 30 นาที
  const onIdle = () => {
    handleLogout()
  }

  // continue session
  const continueSession = () => {
    setShowWarning(false)

    setCountdown(60)

    resetWarningTimer()

    idleTimer.current.reset()
  }

  // sync หลาย tab
  useEffect(() => {
    const interval = setInterval(() => {
      const lastActivity = localStorage.getItem('LAST_ACTIVITY')

      if (!lastActivity) {
        return
      }

      const diff = Date.now() - parseInt(lastActivity)

      if (diff >= SESSION_TIMEOUT) {
        handleLogout()
      }
    }, 10000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  // initial
  useEffect(() => {
    resetWarningTimer()

    return () => {
      clearTimeout(warningTimer.current)
    }
  }, [])

  // countdown timer
  useEffect(() => {
    let interval = null

    if (showWarning) {
      setCountdown(60)

      interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(interval)

            return 0
          }

          return prev - 1
        })
      }, 1000)
    }

    return () => {
      clearInterval(interval)
    }
  }, [showWarning])

  return (
    <>
      <IdleTimer
        ref={idleTimer}
        timeout={SESSION_TIMEOUT}
        onAction={onAction}
        onIdle={onIdle}
        debounce={250}
      />

      <Modal show={showWarning} size="sm" backdrop="static" onHide={continueSession}>
        <Modal.Header>
          <Modal.Title>แจ้งเตือน</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div
            style={{
              textAlign: 'center',
            }}
          >
            ไม่มีการเคลื่นไหว จะออกจากระบบอัตโนมัติภายใน
            <span
              style={{
                fontSize: '1.3rem',
                fontWeight: 'bold',
                color: '#fb8a81',
                marginRight: 15,
                marginLeft: 15,
              }}
            >
              {countdown}
            </span>
            วินาที
          </div>
        </Modal.Body>

        <Modal.Footer style={{ textAlign: 'center' }}>
          <SaveButton icon="check-circle" children="ใช้งานต่อ" onClick={continueSession} />
          <CancelButton icon="sign-out" children="ออกระบบ" onClick={handleLogout} />
        </Modal.Footer>
      </Modal>

      {children}
    </>
  )
}
